import { faAt } from "@fortawesome/free-solid-svg-icons/faAt";
import { faBeer } from "@fortawesome/free-solid-svg-icons/faBeer";
import { faBolt } from "@fortawesome/free-solid-svg-icons/faBolt";
import { faCogs } from "@fortawesome/free-solid-svg-icons/faCogs";
import { faCubes } from "@fortawesome/free-solid-svg-icons/faCubes";
import { faFire } from "@fortawesome/free-solid-svg-icons/faFire";
import { faHome } from "@fortawesome/free-solid-svg-icons/faHome";
import { faMedkit } from "@fortawesome/free-solid-svg-icons/faMedkit";
import { faPhone } from "@fortawesome/free-solid-svg-icons/faPhone";
import { faUniversity } from "@fortawesome/free-solid-svg-icons/faUniversity";
import { faUtensils } from "@fortawesome/free-solid-svg-icons/faUtensils";

export const sectors = [
  {
    name: "Consumer Discretionary",
    abbr: "Cons.Discret.",
    icon: faUtensils,
  },
  {
    name: "Consumer Staples",
    abbr: "Cons.Staples",
    icon: faBeer,
  },
  {
    name: "Energy",
    icon: faFire,
  },
  {
    name: "Financials",
    icon: faUniversity,
  },
  {
    name: "Health Care",
    icon: faMedkit,
  },
  {
    name: "Industrials",
    icon: faCogs,
  },
  {
    name: "Information Technology",
    abbr: "IT",
    icon: faAt,
  },
  {
    name: "Materials",
    icon: faCubes,
  },
  {
    name: "Real Estate",
    icon: faHome,
  },
  {
    name: "Telecommunication Services",
    abbr: "Telecom",
    icon: faPhone,
  },
  {
    name: "Communication Services",
    icon: faPhone,
  },
  {
    name: "Utilities",
    icon: faBolt,
  },
];
